export default __webpack_public_path__ + "static/media/linkedin-s-icon.74f67b08.svg";